import request from '@/utils/request'


//用户登录
//POST /login
export function login(data) {
	return request({
		url: '/loginstudent',
		method: 'post',
		params:data
	})
}

//获取用户信息接口
export function getInfo() {
	return request({
		url: '/detailsUser',
		method: 'get',
	})
}
// 更新用户数据
export function updateUser(data) {
	return request({
		url: '/sys/user/updateMy',
		method: 'put',
		data
	})
}

// 更新用户密码
export function updateUserPass(data) {
	return request({
		url: '/sys/user/updateMyPassword',
		method: 'put',
		params: data
	})
}

//获取分页形式用户数据列表
export function getTeachers(data) {
	return request({
		url: '/sys/user/listByrid',
		method: 'get',
		params: data
	})
}
//查询学生学习课程多少分钟
export function selectStudentTime(data) {
	return request({
		url: '/user/section/selectStudentTime',
		method: 'get',
		params: data
	})
}

//获取当前用户所属组织logo
export function userMajorLogo(data) {
	return request({
		url: '/sysLogo/sysLogoDO/userMajorLogo',
		method: 'get',
		params: data
	})
}

//获取用户未读消息
export function myMessageNotice(data) {
	return request({
		url: '/sysMessage/sysMessageDO/myMessageNotice',
		method: 'get',
		params: data
	})
}
//用户已读消息
export function messageRead(data) {
	return request({
		url: '/sysMessage/sysMessageDO/messageRead',
		method: 'get',
		params: data
	})
}

